import { AgentsPage } from "@/components/admin/agents/agents-page.tsx";
import { PlanGate } from "@/components/plan-gate.tsx";
import { m } from "@/paraglide/messages.js";
import { agentsQueryOptions } from "@/services/agents-service.ts";
import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";
import { RoutePending } from "@/components/custom/route-pending.tsx";

export const Route = createFileRoute("/_authenticated/settings/org/agents")({
	component: RouteComponent,
	pendingComponent: RoutePending,
	loader: async ({ context: { queryClient } }) => {
		queryClient.prefetchQuery(agentsQueryOptions());
	},
	head: () => ({
		meta: [{ title: pageTitle(m.admin_settings_agents_tab()) }],
	}),
});

function RouteComponent() {
	return (
		<PlanGate
			requiredPlan="team"
			featureName={m.plan_gate_feature_agents()}
			variant="lightweight"
			description={m.plan_gate_desc_agents()}
		>
			<AgentsPage />
		</PlanGate>
	);
}
